import React, { useEffect, useRef } from 'react';

const GoogleTranslate = () => {
    const elementRef = useRef(null);
    const scriptLoadedRef = useRef(false);

    // Lijst met talen die je wilt tonen
    const includedLanguages = [
        'nl', 'en', 'de', 'fr', 'es', 'ar', 'pl', 'ro', 'uk', 'sv'
    ].join(',');

    useEffect(() => {
        // Suppress specific Google Translate errors
        const originalError = console.error;
        console.error = (...args) => {
            if (typeof args[0] === 'string' &&
                (args[0].includes('google') ||
                    args[0].includes('translate') ||
                    args[0].includes('TypeError'))) {
                return;
            }
            originalError.apply(console, args);
        };

        // Initialiseer translate widget
        const initTranslate = () => {
            if (!elementRef.current || !window.google || !window.google.translate) return;

            try {
                new window.google.translate.TranslateElement(
                    {
                        pageLanguage: 'nl',
                        includedLanguages: includedLanguages,
                        layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
                        autoDisplay: false
                    },
                    elementRef.current.id
                );
            } catch (e) {
                console.log('Failed to initialize translator:', e);
            }
        };

        // Script load handler
        window.googleTranslateElementInit = () => {
            if (scriptLoadedRef.current) return;
            scriptLoadedRef.current = true;
            setTimeout(initTranslate, 100);
        };

        // Voeg script toe als het nog niet bestaat
        if (!document.querySelector('script[src*="translate_a/element.js"]')) {
            const script = document.createElement('script');
            script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
            script.async = true;
            document.body.appendChild(script);
        } else if (window.google && window.google.translate) {
            // Als het script al geladen is, initialiseer direct
            initTranslate();
        }

        // Stijl injecteren nadat het script is geladen
        const injectCustomStyles = () => {
            // Wacht een moment tot Google Translate is geïnitialiseerd
            setTimeout(() => {
                // Verwijder de Google Translate balk bovenaan de pagina als deze verschijnt
                const gtBanner = document.querySelector('.goog-te-banner-frame');
                if (gtBanner) {
                    gtBanner.style.display = 'none';
                }

                // Stel top terug naar 0 als Google het heeft gewijzigd
                if (document.body.style.top) {
                    document.body.style.top = '0';
                }
            }, 1000);
        };

        // Voer stijl injectie uit wanneer het script is geladen
        if (window.google && window.google.translate) {
            injectCustomStyles();
        } else {
            // Of wacht tot het script is geladen
            const checkInterval = setInterval(() => {
                if (window.google && window.google.translate) {
                    injectCustomStyles();
                    clearInterval(checkInterval);
                }
            }, 300);
            // Stop het controleren na 10 seconden om resources te besparen
            setTimeout(() => clearInterval(checkInterval), 10000);
        }

        // Cleanup functie
        return () => {
            console.error = originalError;
            scriptLoadedRef.current = false;
            clearInterval(window.googleTranslateCheckInterval);
            const script = document.querySelector('script[src*="translate_a/element.js"]');
            if (script) script.remove();
            delete window.googleTranslateElementInit;
        };
    }, []);

    return (
        <>
            <style>
                {`
                    /* Basis container stijl */
                    .google-translate-container {
                        margin: 20px 0;
                        padding: 10px 0;
                    }
                    
                    /* Verbeter de stijl van de Google Translate dropdown */
                    .goog-te-gadget-simple {
                        border: 1px solid #e2e8f0 !important;
                        padding: 8px 12px !important;
                        border-radius: 6px !important;
                        background-color: white !important;
                        font-family: inherit !important;
                        font-size: 14px !important;
                        display: inline-flex !important;
                        align-items: center !important;
                        transition: border-color 0.2s ease !important;
                    }
                    
                    .goog-te-gadget-simple:hover {
                        border-color: #a0aec0 !important;
                    }
                    
                    /* Verbeter de stijl van de tekst binnen de dropdown */
                    .goog-te-gadget-simple .goog-te-menu-value {
                        color: #333 !important;
                        font-family: inherit !important;
                        font-size: 14px !important;
                        display: flex !important;
                        align-items: center !important;
                    }
                    
                    /* Verwijder Google branding en verbeter spacing */
                    .goog-te-gadget-simple .goog-te-menu-value span {
                        margin-right: 12px !important;
                        color: #333 !important;
                    }
                    
                    /* Verberg ongewenste elementen */
                    .goog-te-gadget-simple img,
                    .goog-te-gadget-icon {
                        display: none !important;
                    }
                    
                    /* Verwijder de Google balk bovenaan de pagina */
                    .goog-te-banner-frame {
                        display: none !important;
                    }
                    
                    /* Fix voor body content verschuiving */
                    body {
                        top: 0 !important;
                    }
                    
                    /* Verberg andere elementen */
                    .VIpgJd-ZVi9od-l4eHX-hSRGPd,
                    .skiptranslate:not(:first-of-type) {
                        display: none !important;
                    }
                    
                    /* Stijl voor het dropdown menu dat verschijnt */
                    .goog-te-menu2 {
                        border-radius: 6px !important;
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
                        border: 1px solid #e2e8f0 !important;
                        padding: 8px 0 !important;
                    }
                    
                    .goog-te-menu2-item {
                        padding: 6px 12px !important;
                    }
                    
                    .goog-te-menu2-item:hover {
                        background-color: #f7fafc !important;
                    }
                `}
            </style>
            <div
                ref={elementRef}
                id="translate_element"
                className="google-translate-container"
            />
        </>
    );
};

export default GoogleTranslate;
